import { supabase } from "@/integrations/supabase/client";

// Password sign-in routed through the secure-login edge function, which
// enforces the failed-attempt lockout server-side before verifying credentials.
export async function secureSignIn(
  email: string,
  password: string,
): Promise<{ error: Error | null; locked?: boolean }> {
  const { data, error } = await supabase.functions.invoke("secure-login", {
    body: { email, password },
  });

  if (error) {
    let message = "Invalid login credentials";
    let locked = false;
    try {
      const body = await (error as any).context?.json?.();
      if (body?.error) {
        message = body.error;
        locked = !!body.locked_until;
      }
    } catch {
      // keep generic message
    }
    return { error: new Error(message), locked };
  }

  const session = data?.session;
  if (!session?.access_token || !session?.refresh_token) {
    return { error: new Error(data?.error || "Sign in failed. Please try again.") };
  }

  const { error: sessionError } = await supabase.auth.setSession({
    access_token: session.access_token,
    refresh_token: session.refresh_token,
  });
  return { error: sessionError as Error | null };
}
